module.exports = __webpack_public_path__ + "img/lswax_token.fusion.442286d.png";